module.exports = __webpack_public_path__ + "img/postNavIcon.ccf4ff15.svg";